import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  isOpenCompany: false,
  isQrMenuOpen: false,
  isProfileMenuOpen: false,
  isLangMenuOpen: false,
  isNotificationMenuOpen: false,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    toggleMenu: (state, action) => {
      const { menuName } = action.payload;
      state[menuName] = !state[menuName];
    },
    closeMenu: (state, action) => {
      const { menuName } = action.payload;
      state[menuName] = false;
    },
    closeAllMenus: (state, action) => {
      const { excludeMenu } = action.payload || {}; // Если payload отсутствует, excludeMenu будет undefined
      Object.keys(state).forEach((key) => {
        if (key !== excludeMenu && state[key]) { // Проверяем, что excludeMenu не равен текущему ключу
          state[key] = false;
        }
      });
    },
  },
});

export const { toggleMenu, closeMenu, closeAllMenus } = menuSlice.actions;

export default menuSlice.reducer;